export default __webpack_public_path__ + "static/media/flag_norway.9a6f9c08.svg";